module.exports = __webpack_public_path__ + "static/media/logo.2a8c10b2.svg";